import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as myGlobals from "../../../../app.component";

@Component({
  selector: 'app-view-video',
  templateUrl: './view-video.component.html',
  styleUrls: ['./view-video.component.scss']
})
export class ViewVideoComponent implements OnInit {

  videoName:any;
  videoData:any;
  videosUrl:any;
  public baseUrl = myGlobals.baseFileUrl;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.videoData=data['row'];
    this.videoName=data['row']['videos'];
    this.videosUrl=this.baseUrl+"/homepage/video_gallery/"+this.videoName['file'];
    // console.log(this.videosUrl);
   }

  ngOnInit(): void {
  }

}
